import React, { Component } from 'react';

import api from '../../../../services/api';
import TabletList from '../TableList';

import { BackofficeClientsList, ContentTitle } from './style/BackofficeClientsList';

export default class BriefingsList extends Component {
	state = {
		query: {
			value: '',
		},
		dataClients: [],
	};

	componentDidMount() {
		api.get('/customers')
			.then((response) => {
				this.setState({ dataClients: response.data.data });
			});
	}

	onChange = (e) => {
		const state = {
			...this.state,
			[e.target.name]: {
				...this[e.target.name],
				value: e.target.value,
			},
		};

		return this.setState(state, this.handleSubmit);
	};

	handleSubmit = () => {
		const { query } = this.state;

		api.get(`/customers?query=${query.value}`)
			.then((response) => {
				this.setState({ dataClients: response.data.data });
			});
	};

	render() {
		const { dataClients, query } = this.state;

		return (
			<BackofficeClientsList>
				<div className="table-list">
					<header>
						<i className="fa fa-bullhorn" />
						<ContentTitle className="mb-4 p-0">Clientes Gearbox</ContentTitle>
					</header>

					<div className="filter mb-2">
						<h3 className="mb-2"><label htmlFor="inputLojaVeiculos">Buscar clientes:</label></h3>
						<input
							type="text"
							name="query"
							className="form-control input-txt"
							id="inputLojaVeiculos"
							placeholder="Digite a razão social, o nome fantasia, o cnpj ou o id webmotors"
							value={query.value}
							onChange={this.onChange}
						/>
					</div>

					<div className="table">
						<TabletList
							key={dataClients.id}
							dataThead={['Cliente:', 'CNPJ:', 'ID Webmtors:']}
							dataTbody={dataClients}
							button={{ classButton: 'btn-outline-secondary', value: 'Editar Cliente', onClick: this.buttonClick }}
						/>
					</div>
				</div>
			</BackofficeClientsList>
		);
	}
}
